import { BrowserRouter, Routes, Route } from "react-router-dom";
import { WalletProvider } from "./contexts/WalletContext";
import { AuthProvider } from "./contexts/AuthContext";
import { SnackbarProvider } from "notistack";
import { Layout } from "./components/layout/Layout";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import { ErrorBoundary } from "./components/ErrorBoundary";

// Directly import components without lazy loading
import { Dashboard } from "./features/dashboard/Dashboard";
import { WalletManagement } from "./features/wallet-management/WalletManagement";
import { SubWalletRegistration } from "./features/wallet-management/SubWalletRegistration";
import { CodeRegistration } from "./features/wallet-management/CodeRegistration";
import * as buffer from "buffer";
window.Buffer = buffer.Buffer;

function App() {
  return (
    <BrowserRouter>
      <SnackbarProvider maxSnack={3}>
        <WalletProvider>
          <AuthProvider>
            <ErrorBoundary>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route
                    path="/register-sub-wallet/:token/:walletId"
                    element={<SubWalletRegistration />}
                  />
                  <Route path="/code/:code" element={<CodeRegistration />} />
                  <Route element={<ProtectedRoute />}>
                    <Route
                      path="/wallet-management"
                      element={<WalletManagement />}
                    />
                  </Route>
                </Routes>
              </Layout>
            </ErrorBoundary>
          </AuthProvider>
        </WalletProvider>
      </SnackbarProvider>
    </BrowserRouter>
  );
}

export default App;
